import { render, staticRenderFns } from "./MarketRates3.vue?vue&type=template&id=deb44036&scoped=true"
import script from "./MarketRates3.vue?vue&type=script&lang=js"
export * from "./MarketRates3.vue?vue&type=script&lang=js"
import style0 from "./MarketRates3.vue?vue&type=style&index=0&id=deb44036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb44036",
  null
  
)

export default component.exports